"use client";

import { Button } from '@/components/ui/button';
import Image from 'next/image';
import { useRouter } from 'next/navigation';
import { cn } from '@/lib/utils';

interface MixusLogoProps {
  theme?: 'light' | 'dark'
  className?: string
  width?: number
  height?: number
}

const MixusLogo = ({
  theme = 'light',
  className,
  width = 100,
  height = 30
}: MixusLogoProps) => {
    const router = useRouter();

    const logoSrc = theme === 'dark'
      ? '/logo-svg-dark-mode.svg'
      : '/logo-svg-light-mode.svg'

    const handleClick = () => {
        router.push('/chat');
    };

    return (
        <Button
            onClick={handleClick}
            variant="ghost"
            className={cn("py-0 header-button hover:bg-mixus-light-beige dark:hover:bg-mixus-black focus:bg-transparent focus:outline-none focus:ring-0 active:bg-mixus-light-gray/20 dark:active:bg-mixus-light-gray/10 transition-colors duration-100", className)}
        >
            <div className={cn("relative", className)}>
                <Image
                    src={logoSrc}
                    alt="Mixus"
                    width={width}
                    height={height}
                    className="transition-all"
                    priority
                />
            </div>
        </Button>
    );
};

export default MixusLogo;
